import { useEffect } from 'react';

import axios from 'axios';

import * as constant from '@services/Constants';

const useInterceptors = () => {
  useEffect(() => {
    axios.interceptors.request.use(
      (config) => {
        config.headers.authorization =
          'Basic ' + btoa(`${constant.CREDENTIALS.user}:${constant.CREDENTIALS.password}`);

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (res) => res,
      (err) => {
        return err;
      }
    );
  }, []);
};

export default useInterceptors;
